import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { CheckoutPage } from "./CheckoutPage";
import { CheckoutShell } from "./components/CheckoutShell";
import { Outcome } from "./components/Outcome";
import "./index.css";
import { ApiError } from "@unizpay/ui";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      // Client errors (4xx) won't succeed on retry; network/5xx errors get two more tries.
      retry: (count, err) => !(err instanceof ApiError && err.status >= 400 && err.status < 500) && count < 2,
    },
  },
});

function NotFound() {
  return (
    <CheckoutShell session={undefined}>
      <Outcome tone="neutral" title="Payment not found">
        <p>This payment link is invalid. Please return to the merchant and try again.</p>
      </Outcome>
    </CheckoutShell>
  );
}

// Payment links look like https://pay.example.com/<payment id>#<checkout token>; a single
// path segment, so no router is needed.
const PAYMENT_PATH = /^\/(pay_[0-9A-Za-z]+)\/?$/;
const id = PAYMENT_PATH.exec(window.location.pathname)?.[1];

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {id ? <CheckoutPage id={id} /> : <NotFound />}
    </QueryClientProvider>
  </StrictMode>,
);
